import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby"
import { OutboundLink } from 'gatsby-plugin-google-analytics'

const Hero = props => {
  const { backgrounds, theme } = props;

  return (
    <React.Fragment>
      <section className="hero">
        <h1>
            Yet Another Stack
        </h1>
        <h2>
            User-space network-stack based on DPDK, FreeBSD TCP/IP Stack, Envoy Proxy
        </h2>

         <li>
         <OutboundLink href="https://link.medium.com/ed8VUBu5v0" id="Technology-the-common-denominator-for-business-agility">
            <h3> Technology - the common denominator for business agility </h3>
         </OutboundLink>
         </li>

         <li>
         <OutboundLink href="https://link.medium.com/8C5vrU7x4W" id="ubiquitous-service-mesh">
	    <h3> Ubiquitous Service Mesh </h3>
         </OutboundLink>
         </li>



         <li>
         <OutboundLink href="https://link.medium.com/8fKtobF6LU" id="packet-journey">
            <h3> YAStack: Journey of a packet </h3>
         </OutboundLink>
         </li>



         <li>
         <OutboundLink href="https://link.medium.com/rowNUVAIeT" id="envoy-cmake">
            <h3> envoy-cmake: Adapting YAStack build system for regular envoy </h3>
         </OutboundLink>
         </li>

         <li>
         <OutboundLink href="https://link.medium.com/9cWlqVcElT" id="YAStack blog">
            <h3> The need for Yet Another Stack </h3>
         </OutboundLink>
         </li>


      </section>

      {/* --- STYLES --- */}
      <style jsx>{`
        .hero {
          align-items: center;
          background: ${theme.hero.background};
          background-image: url(${backgrounds.mobile});
          background-size: cover;
          color: ${theme.text.color.primary.inverse};
          display: flex;
          flex-flow: column nowrap;
          justify-content: left;
          min-height: 100vh;
          height: 100px;
          padding: ${theme.space.inset.l};
          padding-top: ${theme.header.height.homepage};
        }

        h1 {
          text-align: center;
          font-size: ${theme.hero.h1.size};
          margin: ${theme.space.stack.l};
          color: ${theme.hero.h1.color};
          line-height: ${theme.hero.h1.lineHeight};
          text-remove-gap: both 0 "Open Sans";

          :global(strong) {
            position: relative;

            &::after,
            &::before {
              content: "›";
              color: ${theme.hero.h1.color};
              margin: 0 ${theme.space.xs} 0 0;
              text-shadow: 0 0 ${theme.space.s} ${theme.color.neutral.gray.k};
            }
            &::after {
              content: "‹";
              margin: 0 0 0 ${theme.space.xs};
            }
          }
        }

        h3 {
          text-align: center;
          font-size: ${theme.font.size.xs};
          margin: ${theme.space.stack.l};
          color: ${theme.hero.h1.color};
          line-height: ${theme.hero.h1.lineHeight};
          text-remove-gap: both 0 "Open Sans";

          :global(strong) {
            position: relative;

            &::after,
            &::before {
              content: "›";
              color: ${theme.text.color.attention};
              margin: 0 ${theme.space.xs} 0 0;
              text-shadow: 0 0 ${theme.space.s} ${theme.color.neutral.gray.k};
            }
            &::after {
              content: "‹";
              margin: 0 0 0 ${theme.space.xs};
            }
          }
        }

        a {
          font-size: ${theme.font.size.s};
          color: ${theme.hero.h1.color};
          onmouseover: link.style.color = "#8080ff";
        }

        button {
          background: ${theme.background.color.brand};
          border: 0;
          border-radius: 50%;
          font-size: ${theme.font.size.m};
          padding: ${theme.space.s} ${theme.space.m};
          cursor: pointer;
          width: ${theme.space.xl};
          height: ${theme.space.xl};

          &:focus {
            outline-style: none;
            background: ${theme.color.brand.primary.active};
          }

          :global(svg) {
            position: relative;
            top: 5px;
            fill: ${theme.color.neutral.white};
            stroke-width: 40;
            stroke: ${theme.color.neutral.white};
            animation-duration: ${theme.time.duration.long};
            animation-name: buttonIconMove;
            animation-iteration-count: infinite;
          }
        }

        @keyframes buttonIconMove {
          0% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
          100% {
            transform: translateY(0);
          }
        }

        @from-width tablet {
          .hero {
            background-image: url(${backgrounds.tablet});
          }

          h1 {
            max-width: 90%;
            font-size: ${`calc(${theme.hero.h1.size} * 1.3)`};
          }

          button {
            font-size: ${theme.font.size.l};
          }
        }

        @from-width desktop {
          .hero {
            background-image: url(${backgrounds.desktop});
          }

          h1 {
            max-width: 80%;
            font-size: ${`calc(${theme.hero.h1.size} * 1.5)`};
          }

          button {
            font-size: ${theme.font.size.xl};
          }
        }
      `}</style>
    </React.Fragment>
  );
};

Hero.propTypes = {
  backgrounds: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default Hero;
